import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        adminBranchId: Cookies.get('adminBranchId') ? parseInt(Cookies.get('adminBranchId'), 10) : null,
        editReportTemplates: Cookies.get('editReportTemplates') === 'true',
    },
    reducers: {
        setAdminBranchId: (state, action) => {
            state.adminBranchId = action.payload;
            // Save to cookie
            if (action.payload) {
                const isProduction = import.meta.env.MODE === 'production';
                Cookies.set('adminBranchId', action.payload.toString(), {
                    secure: isProduction,
                    sameSite: 'Strict',
                    path: '/',
                    expires: 1
                });
            } else {
                Cookies.remove('adminBranchId', { path: '/' });
            }
        },
        clearAdminBranchId: (state) => {
            state.adminBranchId = null;
            Cookies.remove('adminBranchId', { path: '/' });
        },
        setEditReportTemplates: (state, action) => {
            state.editReportTemplates = Boolean(action.payload);
            const isProduction = import.meta.env.MODE === 'production';
            Cookies.set('editReportTemplates', String(Boolean(action.payload)), {
                secure: isProduction,
                sameSite: 'Strict',
                path: '/',
                expires: 1
            });
        },
        clearEditReportTemplates: (state) => {
            state.editReportTemplates = false;
            Cookies.remove('editReportTemplates', { path: '/' });
        },
    },
});

export const { setAdminBranchId, clearAdminBranchId, setEditReportTemplates, clearEditReportTemplates } = authSlice.actions;
export default authSlice.reducer;

